import { render } from "./PricesNav.vue?vue&type=template&id=73dfb84d&scoped=true"
import script from "./PricesNav.vue?vue&type=script&lang=js"
export * from "./PricesNav.vue?vue&type=script&lang=js"

import "./PricesNav.vue?vue&type=style&index=0&id=73dfb84d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73dfb84d"]])

export default __exports__